module.exports = __webpack_public_path__ + "static/assets/mask-guide.svg";